import { createSlice } from "@reduxjs/toolkit";

export const fullScreenMediaSlice = createSlice({
  name: "fullScreenMedia",
  initialState: {
    isModalOpen: false,
    selectedMedia: null,
    type: "image",
  },
  reducers: {
    openFullScreenModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedMedia = action.payload.imageSrc;
      state.type = action.payload.type;
    },
    closeFullScreenModal: (state) => {
      state.isModalOpen = false;
      state.selectedMedia = null;
      state.type = null;
    },
  },
});

export const { openFullScreenModal, closeFullScreenModal } =
  fullScreenMediaSlice.actions;

export default fullScreenMediaSlice.reducer;
